/**
 * Určuje, která scrollovací šipka má být aktivní
 */
export enum DropdownArrowDirection {
    up = "up",
    down = "down",
}
